export default __webpack_public_path__ + "static/media/RedPokeball.e3614fa6.svg";